import React, { useEffect, useMemo, useState } from 'react'
import { ColorRing } from 'react-loader-spinner'
import { Badge, Button, Col, Form, FormGroup, Modal, ModalBody, Spinner } from 'reactstrap'
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon, RSelect } from '../../../../components/Component'
import ReactDataTable from './ReactDataTable/ReactDataTable';
import { WEBSITE_BASE_URL } from '../../../../config'
import ToastExample from '../../../../helpers/toast'
import Content from '../../../../layout/content/Content'
import Head from '../../../../layout/head/Head'
import noimage from '../../../../assets/images/noimage.png';
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { getStoreItem, getStoreItemCategories, getStoreItems } from '../../../../redux/admin/store/action'
import { addNewAddonCategory, changeAddonCategoryType, deleteItemAddon, getAllItems, toggleItem, updateItem, updateItemAddon } from '../../../../redux/admin/item/action'
import { Image, Row, Table } from 'antd'
import { nonActiveFormSubmissionStatus, openFormLoading } from '../../../../redux/common/actions'
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

function StoreItems() {
    const dispatch = useDispatch();

    const { store_id } = useParams();

    const getSelectors = (state) => ({
        items: state.store.store_items,
        item_categories: state.store.store_item_categories,
        form_loading: state.common.form_loading,
        form_submission_status: state.common.form_submission_status,
    });

    const { items, stores, form_loading, form_submission_status, item_categories } = useSelector(getSelectors);
    const [loading, setLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);   //toast state
    const [formData, setFormData] = useState([]);   //form data state defined
    const [editingItem, setEditingItem] = useState([]);   //edit Item state
    const [image, setImage] = useState([]);  // state defined
    const [popular, setPopular] = useState([]);  // state defined
    const [veg, setVeg] = useState([]);  // state defined
    const [recommended, setRecommended] = useState([]);  // state defined
    const [discount, setDiscount] = useState(false);  //discout state defined
    const [categories, setCategories] = useState([]);  // state defined
    const [datas, setData] = useState([]);  //data state defined
    const [addonDetails, setAddonDetails] = useState([]);
    const [editAddon, setEditAddon] = useState([]);
    const [selectedAddonCategory, setSelectedAddonCategory] = useState(null);
    const [deleteAddon, setDeleteAddon] = useState(null);

    const [modal, setModal] = useState({
        edit: false,
        edit_addon: false,
        add_addon: false,
        delete_addon: false,
    });
    useEffect(() => {
        dispatch(getStoreItemCategories(store_id))
        setLoading(true);
        dispatch(getStoreItems(store_id)).then((response) => {
            setLoading(false);
        })
    }, [])

    const listAddonCategories = editingItem?.addoncategories?.map((data) => (
        { value: data.id, label: data.name }
    ));

    const listAddonCategoryType = [
        { value: "SINGLE", label: "SINGLE" },
        { value: "MULTIPLE", label: "MULTIPLE" }];


    //to open edit modal
    const openEditModal = (item) => {
        dispatch(nonActiveFormSubmissionStatus());
        const itemCategories = item_categories?.map((category) => (
            { value: category.id, label: category.name }
        ));
        setCategories(itemCategories);
        setEditingItem(item);
        setImage(null);
        setPopular(item.is_popular === 1 ? true : false)
        setVeg(item.is_veg === 1 ? true : false)
        setRecommended(item.is_recommended === 1 ? true : false)
        setDiscount(true)
        setModal({ edit: true });
    };

    const onFormCancel = () => {
        setModal({ edit: false, edit_addon: false, add_addon: false, delete_addon: false });
        document.getElementByClass("invalid").innerHTML = "";
        resetForm();
        setEditingItem(" ")
        setDiscount(false);
        dispatch(getAllItems());
    };

    const onAddonFormCancel = () => {
        setModal({ edit: true, edit_addon: false, add_addon: false, delete_addon: false });
    };

    const resetForm = () => {
        setFormData({
            name: "",
            description: "",
            store_id: "",
            item_category_id: "",
            price: "",
            mrp: "",
            min_quantity: "",
            max_quantity: "",
            commission_rate: "",
        });
    };

    //form validation with yup
    const itemSchema = yup.object({
        name: yup.string().required(),
        description: yup.string().required(),
        item_category_id: yup.string().required(),
        price: yup.string().required(),
        commission_rate: yup.string().required(),
    });

    //form values
    const defaultValues = useMemo(
        () => ({
            id: editingItem?.id || "",
            name: editingItem?.name || "",
            description: editingItem?.description || "",
            store_id: editingItem?.store_id || "",
            item_category_id: editingItem?.item_category_id || "",
            price: editingItem?.price || "",
            mrp: editingItem?.mrp || "",
            min_quantity: editingItem?.min_quantity || "",
            max_quantity: editingItem?.max_quantity || "",
            commission_rate: editingItem?.commission_rate || "",
        }),
        [editingItem]
    );


    const methods = useForm({
        resolver: yupResolver(itemSchema),
        defaultValues: defaultValues,
    });


    //useform methods
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        control
    } = methods;

    const addAddon = () => {
        dispatch(openFormLoading());
        const new_data = new FormData();
        new_data.append('addon_category_id', selectedAddonCategory);
        new_data.append('name', addonDetails.name);
        new_data.append('price', addonDetails.price);
        new_data.append('item_id', editingItem.id);
        dispatch(addNewAddonCategory(new_data)).then(response => {
            if (response && response.payload && response.payload.success) {
                dispatch(getAllItems());
                setData(items);
                setShowToast(true);
                openEditModal(response.payload?.item)
                setTimeout(() => {
                    setShowToast(false);
                }, 3000);
            }
        }).catch((err) => {
            const response = err.response;
            console.log(response, 'ddd')
        });
    };

    const updateAddon = () => {
        dispatch(openFormLoading());
        const new_data = new FormData();
        new_data.append('id', editAddon.id);
        new_data.append('name', editAddon.name);
        new_data.append('price', editAddon.price);
        new_data.append('item_id', editingItem.id);
        dispatch(updateItemAddon(new_data)).then(response => {
            if (response && response.payload && response.payload.success) {
                dispatch(getAllItems());
                setData(items);
                setShowToast(true);
                openEditModal(response.payload?.item)
                setTimeout(() => {
                    setShowToast(false);
                }, 3000);
            }
        }).catch((err) => {
            const response = err.response;
            console.log(response, 'ddd')
        });
    };

    const deleteOneAddon = () => {
        const new_data = new FormData();
        new_data.append('addon_id', deleteAddon.id);
        new_data.append('item_id', editingItem.id);
        dispatch(deleteItemAddon(new_data)).then(response => {
            if (response && response.payload && response.payload.success) {
                dispatch(getAllItems());
                setData(items);
                setShowToast(true);
                openEditModal(response.payload?.item)
                setTimeout(() => {
                    setShowToast(false);
                }, 3000);
            }
        }).catch((err) => {
            const response = err.response;
            console.log(response, 'ddd')
        });
    };

    const onFormSubmit = (submitData) => {
        dispatch(openFormLoading());
        const new_data = new FormData();
        new_data.append('id', editingItem?.id)
        new_data.append('name', submitData?.name);
        if (image) {
            new_data.append('image', image);
        }
        new_data.append('description', submitData?.description);
        new_data.append('store_id', editingItem?.store_id);
        new_data.append('item_category_id', submitData?.item_category_id);
        new_data.append('price', submitData?.price);
        new_data.append('mrp', submitData?.mrp);
        new_data.append('min_quantity', submitData?.min_quantity);
        new_data.append('max_quantity', submitData?.max_quantity);
        new_data.append('commission_rate', submitData?.commission_rate);
        new_data.append('is_popular', popular);
        new_data.append('is_recommended', recommended);
        new_data.append('is_veg', veg);
        dispatch(updateItem(new_data));
        resetForm();
    };

    useEffect(() => {

        if (modal.edit == true && editingItem && form_loading == false && form_submission_status == true) {
            dispatch(getStoreItems(store_id))
            setData(items);
            setModal({ edit: false });
            setShowToast(true);
            reset(defaultValues);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        } else {
            reset(defaultValues);
        }
    }, [form_loading, modal, form_submission_status]);



    const handleStatus = (e, id) => {
        dispatch(toggleItem(id));
        setTimeout(() => {
            dispatch(getStoreItems(store_id));
            setShowToast(true);
        }, 500);

        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    };

    const dataTableColumns = [
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Image",
            selector: (row) => row.image,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <Image
                        style={{
                            width: "15vh",
                            objectFit: 'cover',
                        }}
                        src={row?.image ? row?.image : noimage}
                    />
                </div>
            )
        },
        {
            name: "Category",
            selector: (row) => row?.item_category?.name,
            sortable: true,
        },
        {
            name: "Status",
            selector: (row) => row.startDate,
            cell: (row) => (
                <Button color={row.is_active ? "success" : "danger"}
                    onClick={(e) => handleStatus(e, row.id)}
                >
                    {row.is_active ? <Icon name="stop-circle-fill" /> : <Icon name="play-circle-fill" />}
                </Button>
            )
        },
        {
            name: "Action",
            selector: (row) => row.id,
            cell: (row) => (
                <Button className="btn btn-info" onClick={() => openEditModal(row)}>
                    <em class="icon ni ni-edit"></em>
                </Button>
            )
        },
    ];


    return (
        <React.Fragment>
            <Head title="Store Items"></Head>
            {loading ?
                <Content>
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
                :
                <Content>
                    <BlockHead size="sm">
                        <BlockBetween>
                            <BlockHeadContent>
                                <BlockTitle tag="h3" page>
                                    Store Items
                                </BlockTitle>
                                <BlockDes className="text-soft">
                                    <p>You have total {items?.length} Items.</p>
                                </BlockDes>
                            </BlockHeadContent>
                            <BlockHeadContent>
                                <div className="toggle-wrap nk-block-tools-toggle">
                                    <ToastExample
                                        show={showToast}
                                    />
                                </div>
                            </BlockHeadContent>
                        </BlockBetween>
                    </BlockHead>
                    <ReactDataTable data={items} columns={dataTableColumns} expandableRows pagination />
                </Content>
            }
            <Modal
                isOpen={modal.edit}
                toggle={() => setModal({ edit: false })}
                className="modal-dialog-centered"
                size="lg"
            >
                <ModalBody>
                    <a
                        href="#cancel"
                        onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                        }}
                        className="close"
                    >
                        <Icon name="cross-sm"></Icon>
                    </a>
                    <div className="p-2 user-select-none">
                        <h5 className="title"> Editing Item - {editingItem?.name}</h5>
                        <div className="mt-4">
                            <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)} encType="multipart/formData">
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Item Name</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="name"
                                            placeholder="Enter Item Name"
                                            ref={register({ required: "This field is required" })}
                                        />
                                        {errors.name && <span className="invalid">{errors.name.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label" >Image </label>
                                        <input
                                            className="form-control"
                                            type="file"
                                            name="image"
                                            accept="image/png, image/jpeg, image/jpg"
                                            onChange={(e) => {
                                                setImage(e.target.files[0])
                                            }}
                                        />
                                        {/* <FormText>upload resolution 1200x1200 pixel</FormText> */}
                                    </FormGroup>
                                </Col>
                                <Col md="12" style={modal.edit ? { display: 'block' } : { display: 'none' }}>
                                    <FormGroup>
                                        <label className="form-label">Current Image </label>
                                        <div className="" id={editingItem.id}>
                                            {editingItem?.image ?
                                                <Image
                                                    style={{
                                                        objectFit: 'cover', height: '20vh'
                                                    }}
                                                    src={editingItem?.image}
                                                />
                                                :
                                                <>
                                                    <img src={noimage} alt="item category" style={{ height: '7vh', width: '7vh' }} />
                                                    <span className='m-1' style={{ color: '#330033', fontSize: '9px' }}>No image found</span>
                                                </>
                                            }
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <FormGroup>
                                        <label className="form-label">Description</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="description"
                                            placeholder="Enter Description"
                                            ref={register({ required: "This field is required" })}
                                        />
                                        {errors.description && <span className="invalid">{errors.description.message}</span>}
                                    </FormGroup>
                                </Col>

                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">{discount ? 'Selling Price' : 'Price'}</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            name="price"
                                            step="0.01"
                                            min={0}
                                            placeholder={discount ? "Enter Selling Price" : "Enter Price"}
                                            ref={register({ required: "This field is required" })}
                                        />
                                        {errors.price && <span className="invalid">{errors.price.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col md={discount ? '4' : '0'}>
                                    <div style={discount ? { display: 'block' } : { display: 'none' }}>
                                        <FormGroup>
                                            <label className="form-label">Market Price</label>
                                            <input
                                                className="form-control"
                                                type="number"
                                                name="mrp"
                                                step="0.01"
                                                min={0}
                                                placeholder="Enter Market Price"
                                                ref={register()}
                                            />
                                        </FormGroup>
                                    </div>
                                </Col>
                                <div className='mt-4 ml-3' onClick={() => setDiscount(!discount)}>
                                    <div className='pt-1' >
                                        <Button className="btn-icon py-1 px-2 btn-dim" color="primary" size="rg" style={{ pointerEvents: 'none' }}>
                                            {discount ? <Icon name="minus-sm" /> : <><Icon name="plus-sm" />Add Discount</>}
                                        </Button>
                                    </div>
                                </div>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Quantity(minimum)</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            name="min_quantity"
                                            min={0}
                                            placeholder="Enter Minimum Quantity"
                                            ref={register()}
                                        />
                                        {errors.min_quantity && <span className="invalid">{errors.min_quantity.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Quantity(maximum)</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            name="max_quantity"
                                            min={0}
                                            placeholder="Enter Maximum Quantity"
                                            ref={register()}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Item Category</label>
                                        <div className="form-control-wrap">
                                            <Controller
                                                name="item_category_id"
                                                control={control}
                                                render={({ onChange, value, ref }) => (
                                                    <RSelect
                                                        options={categories}
                                                        onChange={(val) => onChange(val.value)}
                                                        defaultValue={categories?.find((cat) => cat.value === value)}
                                                    />
                                                )}
                                            />
                                            {errors.item_category_id && (
                                                <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a Category</span>
                                            )}
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Commission Rate</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            name="commission_rate"
                                            step="0.01"
                                            min={0}
                                            placeholder="Enter Commission Rate"
                                            ref={register({ required: "This field is required" })}
                                        />
                                        {errors.commission_rate && <span className="invalid">{errors.commission_rate.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <FormGroup >
                                        <div className="custom-control-sm custom-switch">
                                            <input type="radio" className="custom-control-input" id="popular" checked={popular} onClick={() => setPopular(!popular)} />
                                            <label className="custom-control-label user-select-none" htmlFor="popular">Is Popular </label>
                                        </div>
                                    </FormGroup>

                                    <FormGroup >
                                        <div className="custom-control-sm custom-switch">
                                            <input type="radio" className="custom-control-input" id="recommend" checked={recommended} onClick={() => setRecommended(!recommended)} />
                                            <label className="custom-control-label user-select-none" htmlFor="recommend">Is Recommended </label>
                                        </div>
                                    </FormGroup>

                                    <FormGroup >
                                        <div className="custom-control-sm custom-switch">
                                            <input type="radio" className="custom-control-input" id="veg" checked={veg} onClick={() => setVeg(!veg)} />
                                            <label className="custom-control-label user-select-none" htmlFor="veg">Is Veg </label>
                                        </div>
                                    </FormGroup>
                                </Col>

                                {editingItem?.addoncategories?.length > 0 ?
                                    <>
                                        <div className='my-3 w-100 '>
                                            <h6 className="title">Item Addons</h6>
                                            <hr style={{ margin: '1px solid #d3d3d3' }} />
                                            <Row>
                                                <Col md="6">
                                                    <FormGroup>
                                                        <label className="form-label">Addon Category</label>
                                                        <div className="form-control-wrap">
                                                            <RSelect
                                                                options={listAddonCategories}
                                                                onChange={(val) => setSelectedAddonCategory(val.value)}
                                                                defaultValue={listAddonCategories?.find((cat) => cat.value === selectedAddonCategory)}
                                                            />
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                                {editingItem?.addoncategories?.map((addonCategory) => (addonCategory.id == selectedAddonCategory) && (
                                                    <Col md="6">
                                                        <FormGroup>
                                                            <label className="form-label">Type</label>
                                                            <div className="form-control-wrap">
                                                                {/* <select class="form-control form-control-select w-100" name="addon_category_type" id="addon_category_type"
                                                                    data-placeholder="Select Type" required onChange={(e) => dispatch(changeAddonCategoryType(addonCategory.id, e.target.value))}>
                                                                    <option value="SINGLE" selected={addonCategory.type === "SINGLE"} >SINGLE</option>
                                                                    <option value="MULTIPLE" selected={addonCategory.type === "MULTIPLE"} >MULTIPLE</option>
                                                                </select> */}
                                                                <RSelect
                                                                    options={listAddonCategoryType}
                                                                    onChange={(val) => dispatch(changeAddonCategoryType(addonCategory.id, val.value))}
                                                                    defaultValue={listAddonCategoryType?.find((cat) => cat.value === addonCategory.type)}
                                                                />
                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                ))}
                                            </Row>

                                            {editingItem?.addoncategories?.length > 0 ?
                                                editingItem?.addoncategories?.map((addonCategory) => (addonCategory.id == selectedAddonCategory) && (
                                                    <div className='mt-1 px-3'>
                                                        <div className='text-right w-100'>
                                                            <div className='btn btn-primary btn-icon' onClick={() => {
                                                                setModal({ add_addon: true, edit: false })
                                                            }}>
                                                                <em class="icon ni ni-plus"></em>
                                                            </div>
                                                        </div>
                                                        <table className='mt-1 w-100 table-auto border-separate border-spacing-2 border border-slate-400'>
                                                            <thead className=' '>
                                                                <tr>
                                                                    {/* <th className='border border-slate-300 p-1'>addon Category</th> */}
                                                                    <th className='border border-slate-300 p-1'>addon</th>
                                                                    <th className='border border-slate-300 p-1'>price</th>
                                                                    <th className='border border-slate-300 p-1'>action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {addonCategory?.addons?.length > 0 ? addonCategory?.addons?.map((addon) => (
                                                                    <tr>
                                                                        {/* <th className='border border-slate-300 px-1'>{addonCategory.name}</th> */}
                                                                        <th className='border border-slate-300 px-1'>{addon.name}</th>
                                                                        <th className='border border-slate-300 px-1'>{addon.price}</th>
                                                                        <th className='border border-slate-300 px-1'>
                                                                            <div className='btn btn-sm btn-icon btn-dark mx-2 px-1' onClick={() => {
                                                                                setEditAddon(addon)
                                                                                setModal({ edit_addon: true, edit: false })
                                                                            }}>
                                                                                Edit
                                                                            </div>
                                                                            <div className='btn btn-sm btn-icon btn-danger px-1' onClick={() => {
                                                                                setDeleteAddon(addon)
                                                                                setModal({ delete_addon: true, edit: false })
                                                                            }}>
                                                                                Delete
                                                                            </div>
                                                                        </th>
                                                                    </tr>
                                                                )) :
                                                                    <tr className='text-center'>
                                                                        <td colSpan={3}>
                                                                            -No Addons-
                                                                        </td>
                                                                    </tr>
                                                                }
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                ))
                                                : null}
                                        </div>
                                    </> : null}


                                <Col md="12">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                        <li>
                                            <Button type="submit" color="primary" size="lg" className="btn-block">
                                                {form_loading ? (
                                                    <>
                                                        <Spinner size="sm" color="light" />  Updating Item
                                                    </>
                                                ) : (
                                                    <React.Fragment> Update Item </React.Fragment>
                                                )}
                                            </Button>
                                        </li>
                                        <li>
                                            <a
                                                href="#cancel"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                    onFormCancel();
                                                }}
                                                className="link link-light"
                                            >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </Col>
                            </Form>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

            <Modal
                isOpen={modal.edit_addon}
                toggle={() => setModal({ edit_addon: false, edit: true })}
                className="modal-dialog-centered"
                size="lg"
            >
                <ModalBody>
                    <a
                        href="#cancel"
                        onClick={(ev) => {
                            ev.preventDefault();
                            onAddonFormCancel();
                        }}
                        className="close"
                    >
                        <Icon name="cross-sm"></Icon>
                    </a>
                    <div className="p-2">
                        <h5 className="title"> Edit Addon - {editAddon?.name}  </h5>
                        <div className="mt-4">
                            <Form className="row gy-4" onSubmit={(e) => { updateAddon(e); e.preventDefault() }} >
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label"> Name</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="name"
                                            placeholder="Enter Addon  Name"
                                            value={editAddon.name}
                                            onChange={(e) => {
                                                setEditAddon({ ...editAddon, name: e.target.value })
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Price</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            name="price"
                                            value={editAddon.price}
                                            placeholder="Enter a price"
                                            onChange={(e) => {
                                                setEditAddon({ ...editAddon, price: e.target.value })
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                        <li>
                                            <Button type="submit" color="primary" size="lg" className="btn-block" >
                                                {form_loading ? (
                                                    <>
                                                        <Spinner size="sm" color="light" />  Updating Addon
                                                    </>
                                                ) : (
                                                    <React.Fragment>  Update Addon </React.Fragment>
                                                )}
                                            </Button>
                                        </li>
                                        <li>
                                            <a
                                                href="#cancel"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                    onAddonFormCancel();
                                                }}
                                                className="link link-light"
                                            >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </Col>
                            </Form>
                        </div>
                    </div>
                </ModalBody>
            </Modal>


            <Modal
                isOpen={modal.add_addon}
                toggle={() => setModal({ add_addon: false, edit: true })}
                className="modal-dialog-centered"
                size="lg"
            >
                <ModalBody>
                    <a
                        href="#cancel"
                        onClick={(ev) => {
                            ev.preventDefault();
                            onAddonFormCancel();
                        }}
                        className="close"
                    >
                        <Icon name="cross-sm"></Icon>
                    </a>
                    <div className="p-2">
                        <h5 className="title"> Add Addon </h5>
                        <div className="mt-4">
                            <Form className="row gy-4" onSubmit={(e) => { addAddon(e); e.preventDefault() }} >
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label"> Name</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="name"
                                            placeholder="Enter Addon  Name"
                                            onChange={(e) => {
                                                setAddonDetails({ ...addonDetails, name: e.target.value })
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Price</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            name="price"
                                            placeholder="Enter a price"
                                            onChange={(e) => {
                                                setAddonDetails({ ...addonDetails, price: e.target.value })
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                        <li>
                                            <Button type="submit" color="primary" size="lg" className="btn-block" >
                                                {form_loading ? (
                                                    <>
                                                        <Spinner size="sm" color="light" />  Adding Addon
                                                    </>
                                                ) : (
                                                    <React.Fragment>  Add Addon </React.Fragment>
                                                )}
                                            </Button>
                                        </li>
                                        <li>
                                            <a
                                                href="#cancel"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                    onAddonFormCancel();
                                                }}
                                                className="link link-light"
                                            >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </Col>
                            </Form>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

            <Modal
                isOpen={modal.delete_addon}
                toggle={() => setModal({ delete_addon: false, edit: true })}
                className="modal-dialog-centered"
            >
                <ModalBody className='pt-3 pb-2'>
                    <a
                        href="#cancel"
                        onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                        }}
                        className="close"
                    >
                        <Icon name="cross-sm"></Icon>
                    </a>
                    <div className="p-2">
                        <h5 className="title">Delete Addon{' '}
                            <Badge color="primary">
                                {deleteAddon?.name}
                            </Badge>
                            {' '}
                            ?
                        </h5>
                        <div className='mt-2'>
                            <span>This Item will be deleted. Do you really want to delete this addon ?</span>
                        </div>
                        <div className="mt-3">
                            <ul className="align-center flex-wrap flex-sm-nowrap gx-4">
                                <li>
                                    <Button onClick={(e) => {
                                        e.preventDefault();
                                        deleteOneAddon();
                                    }} color="danger" className="px-4 btn-block">
                                        {form_loading ? (
                                            <>
                                                <Spinner size="sm" color="light" />Deleting
                                            </>
                                        ) : (
                                            <React.Fragment>Delete</React.Fragment>
                                        )}
                                    </Button>
                                </li>
                                <li>
                                    <a
                                        href="#cancel"
                                        onClick={(ev) => {
                                            ev.preventDefault();
                                            onFormCancel();
                                        }}
                                        className="link link-light"
                                    >
                                        Cancel
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

        </React.Fragment>
    )
}

export default StoreItems
